import React, { useState } from "react";
import {
  Button,
  Modal,
  Input,
  DatePicker,
  TimePicker,
  message,
  Upload,
} from "antd";
import "./CreateEventModal.scss";
import { Controller } from "react-hook-form";
import useEventList from "../components/EventList/logic/useEventList";
import { UploadOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";

const CreateEventModal = ({ isModalOpen, setIsModalOpen,includeUpcoming}) => {
  const [file, setFile] = useState(null);
  const props = {
    name: "file",
    action: "https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        setFile(info.file);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const handleCancel = () => {
    reset();
    setIsModalOpen(!isModalOpen);
  };
  const { control, onSubmitEvent, handleSubmit, errors, reset } = useEventList(
    includeUpcoming,
    handleCancel
  );


  const disabledDate = (current) => {
    return current && current < dayjs().endOf('day');
  };

  return (
    <Modal
      title={
        <h1
          style={{
            color: "#185993",
            fontWeight: "600",
            fontSize: "1.2rem",
          }}
        >
          Create Event
        </h1>
      }
      centered
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      width={800}
      footer={[
        <Button key="back" onClick={() => handleCancel()}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit(onSubmitEvent)}
        >
          Add
        </Button>,
      ]}
    >
      <form onSubmit={handleSubmit(onSubmitEvent)}>
        <div className="form-control-modal-event">
          <div className="first-row-modal-event">
            <div className="form-item">
              <label>Title</label>
              <div className="input-container">
                <Controller
                  name="title"
                  control={control}
                  defaultValue=""
                  rules={{ required: "title is required" }}
                  render={({ field }) => (
                    <Input placeholder="Enter a title" {...field} />
                  )}
                />
              </div>
              {errors.title && (
                <span className="error-msg">{errors.title.message}</span>
              )}
            </div>
          </div>
          <div className="first-row-modal-event">
            <div className="form-item">
              <label>Location</label>
              <div className="input-container">
                <Controller
                  name="location"
                  control={control}
                  defaultValue=""
                  rules={{ required: "location is required" }}
                  render={({ field }) => (
                    <Input placeholder="Enter a location" {...field} />
                  )}
                />
              </div>
              {errors.location && (
                <span className="error-msg">{errors.location.message}</span>
              )}
            </div>
          </div>
          <div className="second-row-modal-event">
            <div className="form-item">
              <label>Date</label>
              <div className="input-container">
                <Controller
                  name="date"
                  control={control}
                  defaultValue=""
                  rules={{ required: "date is required" }}
                  render={({ field }) => (
                    <DatePicker format="YYYY-MM-DD" {...field} disabledDate = {disabledDate} />
                  )}
                />
              </div>
              {errors.date && (
                <span className="error-msg">{errors.date?.message}</span>
              )}
            </div>
            <div className="form-item">
              <label>Time</label>
              <div className="input-container">
                <Controller
                  name="range"
                  control={control}
                  rules={{ required: "time is required" }}
                  render={({ field }) => (
                    <TimePicker.RangePicker format="h:mm a" {...field} />
                  )}
                />
              </div>
              {errors.range && (
                <span className="error-msg">{errors.range?.message}</span>
              )}
            </div>
          </div>
          <div className="second-row-modal-event">
            <div className="form-item">
              <label>Longitude </label>
              <div className="input-container">
                <Input />
              </div>
            </div>
            <div className="form-item">
              <label>Latitude </label>
              <div className="input-container">
                <Input />
              </div>
            </div>
            <div className="form-item">
              <label>PlaceQuery </label>
              <div className="input-container">
                <Input />
              </div>
            </div>
          </div>
          <div className="fourth-row-modal-event">
            <div className="form-item">
              <label>Description </label>
              <div className="input-container">
                <Controller
                  name="description"
                  control={control}
                  defaultValue=""
                  rules={{ required: "description is required" }}
                  render={({ field }) => (
                    <TextArea
                      showCount
                      maxLength={750}
                      style={{
                        height: 120,
                        marginBottom: 24,
                        
                      }}
                      placeholder="Enter a description"
                      {...field}
                    />
                  )}
                />
              </div>
              {errors.description && (
                <span className="error-msg">{errors.description?.message}</span>
              )}
            </div>
            <div className="form-item">
              <label>Image </label>
              <div className="input-container">
                <Controller
                  name="file"
                  control={control}
                  defaultValue=""
                  rules={{ required: "image is required" }}
                  render={({ field }) => (
                    <Upload
                      {...props}
                      onChange={(info) => {
                        if (info.file.status === "done") {
                          field.onChange(info.file);
                        }
                      }}
                    >
                      <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                  )}
                />
              </div>
              {errors.file && (
                <span className="error-msg">{errors.file?.message}</span>
              )}
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default CreateEventModal;